import useTranslation from 'next-translate/useTranslation';
import styles from './styles.module.scss';
import Coins from './Coins';
import { useDispatch, useSelector } from 'react-redux';
import { Nullable } from '@starsoft/common/interfaces';
import { RootState } from '@/lib/store';
import { AnyAction, Dispatch } from 'redux';
import { setFiatConversionCoin } from '@/lib/store/wallet/actions';
import { CoinID } from '@starsoft/common/enums';
import { useEffect } from 'react';

export default function CoinConversionModalContent() {
  const { t } = useTranslation('common');

  const selectedCoinId: Nullable<bigint> = useSelector(
    (state: RootState) => state.wallet.conversionCoinId,
  );
  const dispatch: Dispatch<AnyAction> = useDispatch();

  function onUnmount() {
    return () => {
      if (selectedCoinId) {
        return;
      }

      dispatch(setFiatConversionCoin(CoinID.BRL));
    };
  }

  useEffect(onUnmount, [dispatch, selectedCoinId]);

  return (
    <div className={styles.container}>
      <p className={styles.container__text}>
        {t('fiat_conversion_description')}
      </p>

      <Coins />
    </div>
  );
}
